import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const horizontalActionWindowTitleStyles = makeStyles(() => ({
  titleContainer: {
    flex: '1 1 0',
    height: '11.8vh',
    padding: '0 1.97vw',
    alignContent: 'center',
  },
  titleTypography: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.52),
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.25,
    color: themeColor.defaultTextColor,
    fontStyle: 'normal',
    height: '3.12vh',
    marginTop: '85px',
    marginBottom: '88px',
  },
}));

export const horizontalActionWindowButtonGroupStyles = makeStyles(() => ({
  actionWindowButtonContent: {
    width: '100%',
    padding: '0 1.97vw',
    alignContent: 'flex-start',
  },
  actionWindowButton: {
    lineHeight: 1.01,
    letterSpacing: 1.25,
    marginBottom: '20px',
    marginRight: '20px',
    padding: `0 1.5vw`,
    fontSize: vh(1.65),
    '@media (aspect-ratio: 4/3)': {
      fontSize: vh(1.389),
    },
  },
}));

export const styles = makeStyles(() => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
}));
